import HostWizard from './HostWizard';
import Statistics from './Statistics';
import Audits from './Audits';

export const routes = [HostWizard, Statistics, Audits];



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/routes.js